import { render } from "./Communities.vue?vue&type=template&id=3956112f"
import script from "./Communities.vue?vue&type=script&lang=js"
export * from "./Communities.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/embassy/Communities.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3956112f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3956112f', __exports__)) {
    api.reload('3956112f', __exports__)
  }
  
  module.hot.accept("./Communities.vue?vue&type=template&id=3956112f", () => {
    api.rerender('3956112f', render)
  })

}


export default __exports__